var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"editor",attrs:{"id":"chordpro-textarea","role":"textbox","aria-label":"Chord sheet editor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }